import { useEffect } from 'react';
import { useWallet } from '../context/WalletContext';
import { ACTIVE_CHAIN_ID } from '../config/network';

// Runs once. Attempts to switch chain whenever wallet ends up on wrong one.
// Uses only wallet context state — no polling, no reactive callbacks.
export const useNetworkGuard = () => {
  const { account, chainId, switchNetwork } = useWallet();

  useEffect(() => {
    if (!account) return;
    if (chainId && chainId !== ACTIVE_CHAIN_ID) {
      switchNetwork();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, chainId]);
};
